import type { SxProps, Theme } from "@mui/material/styles";

export const card: SxProps<Theme> = (theme) => ({
  bgcolor: "background.paper",
  border: 1,
  borderColor: "divider",
  borderRadius: 2.75,
  boxShadow: 3,
  p: { xs: 2, md: 3 },
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2.5),
});

export const sectionTitle: SxProps<Theme> = {
  fontWeight: 700,
};

export const formStack: SxProps<Theme> = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
  maxWidth: 480,
});

export const shopRow: SxProps<Theme> = (theme) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  p: theme.spacing(1.5, 2),
  border: 1,
  borderColor: "divider",
  borderRadius: 2,
});

export const successText: SxProps<Theme> = (theme) => ({
  color: theme.palette.success.main,
  fontSize: theme.typography.caption.fontSize,
});
